<div [class]="'offer-recommendation-tile offer-recommendation-tile--' + cssClassSuffix">

    <div class="offer-recommendation-tile__debug">
        <span class="material-icons">bug_report</span>
    </div>

    <div class="offer-recommendation-tile__header">
        <span *ngIf="config.title"
              class="offer-recommendation-tile__header__type">
          {{ config.title | translate }}
        </span>
    </div>

    <div class="offer-recommendation-tile__details">
        <div class="offer-recommendation-tile__logo-price">
            <div class="offer-recommendation-tile__logo">
                <img [src]="logoUrl">
            </div>

            <div class="offer-recommendation-tile__price">
                <div class="offer-recommendation-tile__price__price">
                    <app-offer-price [offer]="offer"
                                     [showInstallment]="true"
                    >
                    </app-offer-price>
                </div>
                <div class="offer-recommendation-tile__price__details-btn">
                    <button (click)="offersSectionStateService.showOfferDetails(offer)"
                            class="btn btn--clear-arrow">
                        <span>{{ 'OFFER_SECTION.offerDetails' | translate }}</span>
                        <span class="material-icons">arrow_right</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="offer-recommendation-tile__coverages">

            <div class="offer-recommendation-tile__coverages__primary">
                <ng-container *ngFor="let primaryBox of primaryBoxes">
                    <app-offer-primary-box
                            *ngIf="canShowBox(primaryBox.options, primaryBox.selectedOption, primaryBox.enabled)"
                            class="offer-primary-box"
                            [box]="primaryBox">
                    </app-offer-primary-box>
                </ng-container>
            </div>

            <div class="offer-recommendation-tile__coverages__detail">
                <ng-container *ngFor="let detailBox of detailBoxes">
                    <div    *ngIf="canShowBox(detailBox.options, detailBox.selectedOption, detailBox.enabled)"
                            class="offer-recommendation-tile__coverages__coverage">
                        <app-offer-detail-box class="offer-recommendation-tile__detail-box"
                                              [box]="detailBox">
                        </app-offer-detail-box>
                    </div>
                </ng-container>
            </div>

        </div>

        <div class="offer-recommendation-tile__actions">
            <button class="btn btn--secondary btn--big"
                    (click)="offersSectionStateService.selectOffer(offer)">
                {{ 'OFFER_SECTION.SHARED.buyOnline' | translate }}
            </button>
        </div>
    </div>

</div>
